import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export interface CreateFlowDataProps {
    title: string;
    flowTriggerId: number;
    distribution: number;
    active: boolean;
}

export const createFlow = async (domain: string, data: CreateFlowDataProps): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: data,
        domain,
    });
}